import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import Input from '../../components/form-control/Input';
import * as Yup from 'yup';
import { useState } from 'react';
import { setCommissionRate } from '../../api/requests';
import SelectDropdown, {
  ISelectDropdownItem
} from '../../components/form-control/SelectDropdown';
import { showToast } from '../../utils/miscFunctions';

export interface ISetCommission {
  rate: string;
  type: string;
  teamId: string;
}

const policyTypes = [
  {
    name: 'Comprehensive',
    value: 'COMPREHENSIVE'
  },
  {
    name: 'Third Party',
    value: 'THIRD_PARTY'
  }
];
const SetCommission = ({
  onProceed,
  onClose,
  teamID
}: {
  onProceed: () => void;
  onClose: () => void;
  teamID: string;
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const submitHandler = (values: any) => {
    setSubmitting(true);
    const payload: ISetCommission = {
      teamId: teamID,
      rate: values.rate,
      type: values.type
    };

    setCommissionRate(payload)
      .then((response: any) => {
        showToast.success(response?.message ?? 'Agency commsission rate set successfully', );
        onProceed();
      })
      .catch((error: any) => {
        showToast.error(error?.description || error?.message);
      })
      .finally(() => setSubmitting(false));
  };
  return (
    <div className="bg-white rounded-xl dark:bg-darkBg">
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            type: '',
            rate: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            rate: Yup.string().required('Commission rate is required.'),
            type: Yup.string().required('Policy type is required.')
          })}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <div className="mb-4">
                  <SelectDropdown
                    label="Policy Type"
                    name="type"
                    list={policyTypes?.map((policyType: any) => ({
                      name: policyType.name,
                      value: policyType.value
                    }))}
                    listSelectedValue={values.type}
                    onChange={(val: ISelectDropdownItem | null) => {
                      setFieldValue('type', val);
                    }}
                    search
                    searchPlaceHolder="Search policy type"
                    onBlur={handleBlur}
                    placeholder="Select Policy Type"
                    error={touched.type ? errors.type : undefined}
                    helperText={touched?.type ? errors.type : undefined}
                    required
                  />
                </div>
                <div className="">
                  <Input
                    label="Commission rate"
                    placeholder="Enter a commission percentage"
                    name="rate"
                    value={values.rate}
                    type="number"
                    wrapperClasses=""
                    required
                    error={errors.rate}
                    onChange={handleChange}
                    onBlur={handleChange}
                    helperText={errors.rate}
                  />
                </div>
              </div>

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
              fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>

            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SetCommission;
